import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { setMsalTokenGetter, clearMsalTokenGetter } from "./msalTokenProvider";
import { loginRequest } from "./msalConfig";

/**
 * Registers the MSAL token getter with the API client so fetchApi can use id_token from MSAL.
 */
export function MsalTokenRegistration() {
  const { instance, accounts } = useMsal();

  useEffect(() => {
    if (accounts.length === 0) return;

    setMsalTokenGetter(async () => {
      try {
        const result = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });
        return result.idToken ?? result.accessToken ?? null;
      } catch {
        return null;
      }
    });

    return () => clearMsalTokenGetter();
  }, [instance, accounts]);

  return null;
}
